import React from 'react'
import ProjectDetails from '../ProjectDetails'
import FarmerPayTable from './FarmerPayTable'
import BreadCrumb from '../../../../../layout/BreadCrumb'

function FarmerPayList() {
  return (
    <div>
      <BreadCrumb
              breadcrumbs={[
                { title: "Farmers", path: "/farmers-list" },
                { title: "Expression List", path: "/expression-view" },
                { title: "Farmer Pay Form" },
              ]}
            />
      <ProjectDetails/>
      <FarmerPayTable/>
    </div>
  )
}

export default FarmerPayList
